import type { AnalyticsMarketsProps } from '@/components/MarketBlock/MarketBlock.types';

export const getAnalyticsMarkets = ({
  line_id,
  outcomes_id,
  odds,
  text = '',
  category,
  championships,
  matchId,
  sportCategory,
  isOutright,
}: AnalyticsMarketsProps) => {
  const baseData = { line_id, outcomes_id, odds, text, cls: 'lineInfo_market_odd_select' };

  if (isOutright) {
    const outrightData = {
      ...baseData,
      sport_category: sportCategory,
      category,
      championships,
      match_id: matchId,
    };

    return {
      select: { click: { eventName: 'sportOutright_outcome_select', data: outrightData } },
      unselect: { click: { eventName: 'sportOutright_outcome_unselect', data: outrightData } },
    };
  }

  return {
    select: { click: { eventName: 'lineInfo_market_odd_select', data: baseData } },
    unselect: { click: { eventName: 'lineInfo_market_odd_unselect', data: baseData } },
  };
};

export const getAnalyticsDataForFavorites = (line_id: number, group_id: string, text = '') => ({
  lineInfo_market_addFavorite_icon: {
    click: {
      eventName: 'lineInfo_market_addFavorite_icon_click',
      data: {
        cls: 'lineInfo_market_addFavorite_icon_click',
        line_id,
        group_id,
        text,
      },
    },
  },
  lineInfo_market_delFavorite_icon: {
    click: {
      eventName: 'lineInfo_market_delFavorite_icon_click',
      data: {
        cls: 'lineInfo_market_delFavorite_icon_click',
        line_id,
        group_id,
        text,
      },
    },
  },
});
